<template>
    <div>
      <h3 class="header-title">Tutor List</h3>
      <label>Let’s see your Tutor List.</label>
  
      <br />
  
      <div v-if="Busy == true">
        <CCol sm="12" md="12">
          <div class="app flex-row align-items-center">
            <div class="container d-flex justify-content-center">
              <PulseLoader float />
            </div>
          </div>
        </CCol>
      </div>
  
      <div v-else>
        <CCol sm="12" class="mt-4">
          <CRow>
            <!-- search -->
            <CCol sm="12">
              <CRow>
                <CCol sm="3">
                  <CInput
                    type="text"
                    placeholder="Search...."
                    v-model.lazy="SearchQuery"
                  />
                </CCol>
              </CRow>
            </CCol>
  
            <!-- add and assign teacher -->
            <CCol sm="12">
              <div style="float: right">
                <CButton 
                  class="btn custom-btn-lgt ml-2" 
                  type="button" 
                  @click="OpenCreateTeacher()"
                >
                  <CIcon name="cil-plus" />Create Teacher
                </CButton>  

                <CButton
                  class="btn custom-btn-lgt"
                  type="button"
                  @click="OpenAssignTeacher()"
                >
                  <CIcon name="cil-plus" />Assign Teacher
                </CButton>
              </div>
            </CCol>
          </CRow>
        </CCol>
  
        <br />
  
        <CCol sm="12">
          <div>
            <CRow>
              <CCol sm="4"> </CCol>
              <CCol sm="4"></CCol>
              <CCol sm="4"></CCol>
            </CRow>
          </div>
  
          <!-- <div style="overflow-x: inherit;"> -->
          <CDataTable
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            :items="teaCountry"
            :fields="fields"
            items-per-page-select
            :items-per-page="small ? 5 : 10"
            :dark="dark"
            clickable-rows
            sorter
            pagination
          >
            <template #ID="{ item }">
              <td>
                {{ item.Id }}
              </td>
            </template>

            <template #Profile="{ item }">
              <td>
                <img
                  v-if="item.profileImagePath == null"
                  style="
                    border: 1px solid #eee;
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    object-fit: cover;
                  "
                  src="../assets/img/default.png"
                  class="grey lighten-2 mt-2"
                />

                <img
                  v-else
                  style="
                    border: 3px solid #ddd;
                    background: #fff;
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    object-fit: cover;
                  "
                  :src="getPic(item)"
                  class="grey lighten-2 mt-2"
                />
              </td>
            </template>

            <template #Name="{ item }">
              <td>
                <h6 style="color: #1e109c" class="text-uppercase">
                  {{ item.Name }}
                </h6>
              </td>
            </template>

            <template #Email="{ item }">
              <td>
                {{ item.Email }}
              </td>
            </template>

            <template #Phone="{ item }">
              <td>
                {{ item.Phone }}
              </td>
            </template>

            <template #Status="{ item }">
              <td>
                {{ item.Status }}
              </td>
            </template>

            <template #Action="{ item }">
              <td>
                <CDropdown
                  toggler-text="Action"
                  class="m-2 btn-act"
                  color="primary"
                >
                  <CDropdownItem @click="OpenUpdate(item)">Edit</CDropdownItem>
                  <CDropdownItem @click="OpenDelete(item)">Delete</CDropdownItem>
                </CDropdown>
              </td>
            </template>
          </CDataTable>
          <!-- </div> -->
        </CCol>

        <!-- Modal Create Teacher -->
        <CModal
          title="Create Teacher"
          size="md"
          :show.sync="CreateTeacherModal"
          :close-on-backdrop="false"
          :close-on-esc="false"
        >
          <div>
            <h6><strong>FORM TEACHER</strong></h6>
            <br />
            <CCol sm="12">
              <CRow>
                <CCol sm="3"> Name </CCol>
                <CCol sm="9">
                  <CInput type="text" v-model="Name" />
                </CCol>
                <CCol sm="3"> Email </CCol>
                <CCol sm="9">
                  <CInput type="text" v-model="Email" />
                </CCol>
                <CCol sm="3"> Phone </CCol>
                <CCol sm="9">
                  <CInput type="text" v-model="Phone" />
                </CCol>
                <CCol sm="3"> Status </CCol>
                <CCol sm="9">
                  <v-select
                    v-model="selectedStatusTeacher"
                    :options="statusList"
                    label="name"
                    placeholder="--Choose Status--"
                    class="custom-vselect no-bordered"
                    @click.stop
                  ></v-select>
                </CCol>
              </CRow>
            </CCol>
          </div>
          <template #footer>
            <CButton
              type="submit"
              class="p-2"
              color="info"
              @click="SubmitTeacherManual"
              >Proceed</CButton
            ></template
          >
        </CModal>
  
        <!-- Modal Assign Teacher -->
        <CModal title="Assign Teacher" size="md" :show.sync="AssignTeacherModal">
          <div>
            <h6><strong>ASSIGN AS TUTOR</strong></h6>
            <br />
            <CCol sm="12">
              <CRow>
                <CCol sm="3"> Email </CCol>
                <CCol sm="9">
                  <CInput type="text" v-model="ParentEmail" />
                </CCol>
              </CRow>
            </CCol>
          </div>
          <template #footer>
            <CButton
              type="submit"
              class="p-2"
              color="info"
              @click="AssignTutor()"
              >Proceed</CButton
            ></template
          >
        </CModal>
  
        <!-- Modal Edit Teacher -->
        <!-- <CModal
          title="Edit Subject"
          size="md"
          :show.sync="EditSubjectModal"
          :close-on-backdrop="false"
          :close-on-esc="false"
        >
          <div>
            <h6><strong>DETAIL SUBJECT</strong></h6>
            <br />
            <CCol sm="12">
              <CRow>
                <CCol sm="5">Subject name</CCol>
                <CCol sm="7">
                  <CInput type="text" v-model="SubjectNames" />
                </CCol>
                <CCol sm="5"> Grade Name </CCol>
                <CCol sm="7">
                  <v-select
                    v-model="SelectedGradeNames"
                    :options="gradesName"
                    label="Name"
                    placeholder="--Please Select Grade--"
                  ></v-select>
                  <br />
                </CCol>
  
                <CCol sm="5"> Class name </CCol>
                <CCol sm="7">
                  <v-select
                    v-model="SelectedClassNames"
                    :options="classes"
                    label="Name"
                    placeholder="Please Select Class"
                  >
                  </v-select>
                  <br />
                </CCol>
                <CCol sm="5"> Student Rate (per Month) or (per Hour) </CCol>
                <CCol sm="7">
                  <CInput type="number" v-model="StudentFees" />
                </CCol>
  
                <CCol sm="8" class="mt-4 mb-3">
                  <h6>
                    <strong>DETAIL RATE TEACHER</strong>
                  </h6></CCol
                >
                <CCol sm="4" class="mt-4 mb-3">
                  <CButton
                    class="button mr-2 mt-2 btn-success"
                    @click="AddHourRate"
                    size="sm"
                  >
                    <CIcon name="cil-plus" /> Add New Rate
                  </CButton></CCol
                >
                <br />
                <table class="table">
                  <thead>
                    <th>Hour</th>
                    <th>Rate</th>
                    <th></th>
                  </thead>
                  <tbody>
                    <tr v-for="item in teacherRate" v-bind:key="item.Id">
                      <td>{{ item.Hour }}</td>
                      <td>{{ item.Rate }}</td>
                      <td>
                        <CButton
                          type="button"
                          class="btn-danger"
                          @click="OpenDeleteTeacherRate(item)"
                          >X Delete</CButton
                        >
                      </td>
                    </tr>
                    <tr
                      v-for="(item, index) in teacherRates"
                      v-bind:key="item.Id"
                    >
                      <td><CInput type="text" v-model="item.Hours" /></td>
                      <td><CInput type="text" v-model="item.Rate" /></td>
                      <td>
                        <button
                          type="button"
                          class="text-center button btn-xs btn-danger"
                          v-on:click="removeRow(index)"
                        >
                          -
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CRow>
            </CCol>
          </div>
          <template #footer>
            <CButton
              type="submit"
              class="p-2"
              color="info"
              @click="UpdateSubject(SubjectId)"
              >{{ lblSubject }}</CButton
            ></template
          >
        </CModal> -->
      </div>
  
        <!-- Modal Delete Teacher -->
        <CModal 
          size="md" 
          :show.sync="DeleteSubject"
          :close-on-backdrop="false"
          :close-on-esc="false"
        >
          <div class="text-center">
            <h3 class="custom-title-popup" style="color: #000a2c">
              Delete Subject
            </h3>
            <br />
          </div>
          <div class="text-center">
            <h4 class="sub-title-header" style="color: #000a2c">
              Are you sure you want to delete the<br />
              subject?
            </h4>
            <br />
          </div>
          <template #footer>
            <div class="text-center">
              <CButton
                type="submit"
                size="lg"
                color="info"
                @click="DeleteSubjects()"
                >Yes, sure.</CButton
              >
            </div>
          </template>
        </CModal>
  
    </div>
  </template>
  
  
  <script>
  import _ from "lodash";
  import Vue from "vue";
  import $ from "jquery";
  Vue.use(require("vue-moment"));
  import moment from "moment";
  import PulseLoader from "vue-spinner/src/PulseLoader.vue";
  
  import vSelect from "vue-select";
  import VuejsDialog from "vuejs-dialog";
  import "vuejs-dialog/dist/vuejs-dialog.min.css";
  Vue.component("v-select", vSelect);
  
  import "vue-select/dist/vue-select.css";
  import "vue-select/src/scss/vue-select.scss";
  
  Vue.use(VuejsDialog);
  import jQuery from "jquery";
  
  export default {
    components: {
      PulseLoader,
    },
    data() {
      return {
        subjects: [],
        SearchQuery: "",
        teaCountry: [],
        perPage: 10,
        pagination: {},
        currentPage: 1,
        DeleteSubject: false,
  
        Busy: false,
        
        fields: [
          { key: "ID" },
          { key: "Profile" },
          { key: "Name" },
          { key: "Email" },
          { key: "Phone" },
          { key: "Status" },
          { key: "Action" },
        ],
  
        FormSubject: false,
        FormGrade: false,
        FormSchedule: false,
        FormReport: false,
  
        UpdateFormSubject: false,
  
        Name: "",
        
        small: "",
        fixed: "",
  
        EditSchedule: false,
  
        subjectsDetails: {},
        students: [],
        selectedStudents: "",
        MonthName: "",
        TestName: "",
        Score: "",
  
        gradesTc: [],
        FilteredGradeClass: [],
        teachers: [],
        selectedTeacher: "",
        FormAssignTeacher: false,
        teacherList: [],
  
        subjectsData: [],
        FilteredTeacherList: [],
  
        FilteredReportCard: [],
        updateReportCard: false,
        MonthNames: "",
        TestNames: "",
        Scores: "",
  
        FilterWeeklySchedule: [],
  
        gridData: [
          {
            name: "Chuck Norris",
            power: Infinity,
          },
          {
            name: "Bruce Lee",
            power: 9000,
          },
          {
            name: "Jackie Chan",
            power: 7000,
          },
          {
            name: "Jet Li",
            power: 8000,
          },
        ],
  
        ScheduleModal: false,
        ScheduleDateTime: "",
        ScheduleDateTimeEnd: "",
        interval: 0,
        selectedTeachers: "",
  
        ReportModal: false,
  
        AssignTeacherModal: false,
  
        SubjectNames: "",
        selectedGradeNames: "",
        selectedClassNames: "",
        StudentFees: "",
  
        EditSubjectModal: false,
  
        SelectedGradeNames: {},
        SelectedClassNames: {},
  
        teacherRate: [],
  
        SubjectModal: false,
        GradeModal: false,
        SearchQueryTeacher: "",
  
  
        lblBtn: "Proceed",
        lblBtnGrade: "Proceed",
        lblBtnSchedule: "Proceed",
        lblAssign: "Assign Teacher",
        lblSubject: "Proceed",
  
        SelectedSubjectNames: {},
        subjectsDataSchedule: [],
  
        ScheduleDateTimes: "",
        ScheduleDateTimeEnds: "",
        intervals: 1,

        CreateTeacherModal: false,
        AssignTeacherModal: false,

        Name: "",
        Phones: "",
        Emails: "",
        statusList: [
        {
          name: "active",
        },
        {
          name: "deleted",
        },
        {
          name: "removed",
        },
        {
          name: "registered",
        },
      ],
  
        user: {},
        currentDate: new Date().toISOString().substring(0, 10),
      };
    },
    async mounted() {
      this.SessionUserIdNo();
      let isAuth = await this.UserAuth();
  
      if (isAuth) {
        this.Busy = false;
        this.GetTeacherCountries(this.user.tuitioncenter);
      } else {
        this.GoToLogin();
      }
    },
    // computed: {
    //   FilteredSubjectsList() {
    //     if (this.SearchQuery === "") return this.FilteredSubjects;
    //     return this.FilteredSubjects.filter((item) => {
    //       //teacher name
    //       for (const { Name } of item.Teachers) {
    //         if (Name.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1) {
    //           return item;
    //         }
    //       }
  
    //       //teacher rate
    //       for (const { Hour, Rate } of item.RateTeacher) {
    //         if (
    //           Hour.toString().indexOf(this.SearchQuery.toString()) > -1 ||
    //           Rate.toString().indexOf(this.SearchQuery.toString()) > -1
    //         ) {
    //           return item;
    //         }
    //       }
  
    //       //schedule
    //       for (const { ScheduleTime, ScheduleTimeEnd } of item.WeeklySchedules) {
    //         if (
    //           ScheduleTime.toString().indexOf(this.SearchQuery.toString()) > -1 ||
    //           ScheduleTimeEnd.toString().indexOf(this.SearchQuery.toString()) > -1
    //         ) {
    //           return item;
    //         }
    //       }
  
    //       //subject name
    //       if (
    //         item.SubjectName.toLowerCase().indexOf(
    //           this.SearchQuery.toLowerCase()
    //         ) > -1
    //       ) {
    //         return item;
    //       }
  
    //       //Grade name
    //       if (
    //         item.Grade.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1
    //       ) {
    //         return item;
    //       }
  
    //       //Class name
    //       if (
    //         item.ClassName.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) >
    //         -1
    //       ) {
    //         return item;
    //       }
  
    //       //student fee
    //       const fee = item.StudentFee?.toString() || "";
    //       if (fee.indexOf(this.SearchQuery.toString()) > -1) {
    //         return item;
    //       }
    //     });
    //   },
    // },
  
    methods: {
      SessionUserIdNo() {
        return this.$API
          .get(this.$LoginUserDetailAdmin, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.user = response.data;
              // GetTeacherCountries(this.user.tuitioncenter);
              console.log("testtc", this.user.tuitioncenter);

              this.$API
              .get(this.$GetTeacherCountry + "?tcId=" + this.user.tuitioncenter, {
                withCredentials: true,
              })
              .then((response) => {
                if (response.status == 200 && response.data != null) {
                  this.Busy = false;
                  this.teaCountry = response.data;
                  console.log("testcountry", this.teaCountry);
                  this.getPic(this.teaCountry);
                }
              });
            }
          });
      },
      
      // GetTeacherCountries() {
      //   console.log("testtcs", this.user.tuitioncenter);
      //   this.$API
      //     .get(this.$GetTeacherCountry + "?tcId=" + this.user.tuitioncenter, {
      //       withCredentials: true,
      //     })
      //     .then((response) => {
      //       if (response.status == 200 && response.data != null) {
      //         this.Busy = false;
      //         this.teaCountry = response.data;
      //         console.log("testcountry", this.teaCountry);
      //         this.getPic(this.teaCountry);
      //       }
      //     });
      // },

      getPic(item) {
      return "https://pickiddo.com" + item.profileImagePath;
    },
      

      OpenCreateTeacher() {
        console.log("testtcsasd", this.user.tuitioncenter);
        this.CreateTeacherModal = true;
      },

      async SubmitTeacherManual() {
        const formData = new FormData();

        formData.append("Name", this.Name);
        formData.append("Email", this.Email);
        formData.append("Phone", this.Phone);
        formData.append("UserType", "teacher");

        formData.append("PasswordHash", "cellnet777#");


        return this.$API
          .post(this.$InsertRegisterTeacher, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data == 1) {
              this.Busy = false;
              this.$dialog.alert("Success saved").then(function () {});
              this.CreateTeacherModal = false;
              this.GetTeacher();
            } else {
              this.Busy = false;
              this.$dialog.alert("You have reached limit").then(function () {});
              this.CreateTeacherModal = false;
              this.GetTeacher();
            }
          })
          .catch((error) => {
            this.Busy = false;
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });        
      },

      AssignTutor: function () {
        const formData = new FormData();

        formData.append("Email", this.ParentEmail);
        formData.append("UserType", "teacher");

        return this.$API
          .post(this.$AssignTeacher, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.TeacherModal = false;
              this.$dialog.alert("Success saved").then(function () {});
            } else {
              this.Busy = false;
              this.$dialog.alert("Error to saved ").then(function () {});
            }
          })
          .catch((error) => {
            this.Busy = false;
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      },

      // CloseCreateTeacher() {
      //   this.CreateTeacherModal = true;
      // },
  
      OpenAssignTeacher() {
        this.AssignTeacherModal = true;
      },

      // CloseAssignTeacher() {
      //   this.AssignTeacherModal = false;
      // },

      // ApplyFilter: function () {
      //   var arr = _.orderBy(this.FilteredSubjects, ["SubjectName"], ["asc"]);
      //   if (_.isEmpty(arr) == false) {
      //     const result = _.filter(arr, ({ SubjectName, Teachers }) =>
      //       _.some([
      //         _.includes(!SubjectName || SubjectName.toLowerCase(), [
      //           this.SearchQuery.toLowerCase(),
      //         ]),
      //       ])
      //     );
      //     this.FilteredSubjects = result;
      //   }
      // },
      // FilteredData() {
      //   console.log("masuk");
      //   this.FilteredSubjects = this.subjects;
  
      //   if (this.selectedGrade !== "ALL GRADE")
      //     this.FilteredSubjects = _.filter(
      //       this.FilteredSubjects,
      //       (item) => item.Grade === this.selectedGrade
      //     );
  
      //   if (this.selectedClass !== "ALL CLASS")
      //     this.FilteredSubjects = _.filter(
      //       this.FilteredSubjects,
      //       (item) => item.ClassName === this.selectedClass
      //     );
      // },
      
      // OpenDeleteTeacherRate(item) {
      //   const formData = new FormData();
  
      //   formData.append("Id", item.Id);
  
      //   return this.$API
      //     .post(this.$DeleteTeacherRate, formData, {
      //       withCredentials: true,
      //     })
      //     .then((response) => {
      //       this.info = response.data;
  
      //       if (response.status == 200) {
      //         this.$API
      //           .get(this.$GetRateTeacherById + "?id=" + this.subjectId, {
      //             withCredentials: true,
      //           })
      //           .then((response) => {
      //             if (response.status == 200 && response.data != null) {
      //               this.teacherRate = response.data;
      //             }
      //           });
      //       } else console.log("Error Deleting");
      //     })
      //     .catch((error) => {
      //       console.log(error);
      //     });
      // },
  
      
      // DeleteSubjects(SubjectId) {
      //   const formData = new FormData();
  
      //   formData.append("Id", SubjectId);
  
      //   return this.$API
      //     .post(this.$DeleteSubject, formData, {
      //       withCredentials: true,
      //     })
      //     .then((response) => {
      //       this.info = response.data;
  
      //       if (response.status == 200) {
      //         this.$dialog.alert("Details Subjects Deleted!");
      //         this.RefreshData();
      //       } else console.log("Error Deleting");
      //     })
      //     .catch((error) => {
      //       console.log(error);
      //     });
      // },

    },
  };
  </script>